import { animate, animateChild, group, query, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';
import { PageBase } from 't4core';
import { LocalStorage } from 't4core';
import { AuthService } from 't4core';
import { TranslationService } from 't4core';


@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    animations: [
        trigger('formState', [
            state('visible', style({
                opacity: 1.0,
                display: 'block'
            })),
            state('hidden', style({
                opacity: 0,
                display: 'none'
            })),
            transition('hidden => visible', [animate('50ms 50ms ease-in')]),
            transition('visible => hidden', [animate('50ms ease-out')])
        ]),
        trigger('lockState', [
            state('true', style({ top: '17px' })),
            state('false', style({ top: '55px' })),
            transition('false => true', [animate('500ms ease-in')])
        ]),
        trigger('leftDialogState', [
            state("void", style({ left: '-320px', opacity: 0 })),
            state('true', style({
                left: 'calc((100vw - 640px)/2)',
                opacity: 1
            })),
            state('false', style({
                left: '-320px',
                opacity: 1
            })),
            transition('* => false', [animate('500ms 1000ms ease-in')]),
            transition('* => true', [animate('500ms ease-out')]),
        ]),
        trigger('rightDialogState', [
            state("void", style({ right: '-320px', opacity: 0 })),
            state('true', style({
                right: 'calc((100vw - 640px)/2)',
                opacity: 1
            })),
            state('false', style({
                right: '-320px',
                opacity: 1
            })),
            transition('* => false', [animate('500ms 1000ms ease-in')]),
            transition('* => true', [animate('500ms ease-out')]),
        ]),
        trigger('backgroundState', [
            state('true', style({
                opacity: 1,
                margin: '0 0 0 0',
                display: 'block'
            })),
            state('false', style({
                opacity: 0,
                margin: '0 0 0 0',
                display: 'none'
            })),
            transition('true => false', [
                group([
                    query('@leftDialogState', [animateChild()]),
                    query('@rightDialogState', [animateChild()]),
                    animate('500ms 1000ms ease-in'),
                ]),
            ])
        ]),
    ]
})
export class LoginComponent extends PageBase implements OnInit {
    @Output() LoginComplete = new EventEmitter<boolean>();

    private loadingMessages = [
        'Checking tyre pressures',
        'Polishing hard tops',
        'Adjusting bow tie',
        'Shortening brake distances',
        'Rehearsing small talk',
        'Practicing friendly smiles',
        'Putting customer first',
        'Reiterating unique selling points',
        'Optimizing fleet',
        'Creating a welcoming atmosphere',
        'Performing safety checks',
        'Verifying housing integrity',
        'Verifying trailer lights',
        'Cleaning trailers',
        'Playing with the winsch'
    ];
  public currentMessage: string;

    constructor(private auth: AuthService, private localStorage: LocalStorage, private translations: TranslationService, el: ElementRef) {
        super(el);
    }

    public ngOnInit() {
        var savedData = this.localStorage.getObject("AuthenticationData");
        if (savedData && savedData.password != undefined) {
            this.locationId = savedData.locationId;
            this.username = savedData.username;
            this.password = savedData.password;

            this.Login();
        } else {
            this.subForms.login = "visible";
            this.subForms.loading = "hidden";
        }
    }

    public isOpen: boolean = true;
    public isAuthenticated: boolean = false;
    public isSigningIn: Boolean = false;
    public subForms = {
        login: "hidden",
        loading: "visible",
        remind: "hidden",
        reminderSent: "hidden",
        ie: "hidden"
    };

    public failed: boolean = false;

    public locationId: string;
    public username: string;
    public password: string;

    public forgotLocationId: boolean;
    public regNo1: string;
    public regNo2: string;

  public resetEmail: string;
  public userEmail: string;

    public async Login() {
        let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
        if (isIEOrEdge) {
            this.subForms.ie = "visible";
            this.subForms.login = "hidden";
            this.subForms.loading = "hidden";
        } else {
            this.initLogin();
        }
    }

    public async initLogin() {
        this.isSigningIn = true;
        this.subForms.ie = "hidden";
        this.subForms.login = "hidden";
        this.subForms.loading = "visible";
        this.subForms.ie = "hidden";
        this.failed = false;

        this.changeMessage();

        var x = false;
        try {
            var x = await this.auth.Authenticate(this.locationId, this.username, this.password);
        } catch (ex) {
          console.log(ex);
        }

        if (x) {
            Promise.all(
                [
                    this.translations.load(),
                ]
            ).then(() => {
              this.isAuthenticated = true;
                this.isSigningIn = false;
                this.isOpen = false;
                var savedData = {
                    locationId: this.locationId,
                    username: this.username,
                    password: this.password,
                };

                this.localStorage.setObject("AuthenticationData", savedData);
            });
            return;
        }

        // Failed
        this.isSigningIn = false;
        this.subForms.login = "visible";
        this.subForms.loading = "hidden";
        this.failed = true;
        //this.localStorage.setObject("AuthenticationData", null);
  }

    public InitRemind() {
        this.subForms.remind = "visible";
        this.subForms.login = "hidden";
    }

    public async ResetPassword() {
        this.subForms.loading = "visible";
        this.subForms.remind = "hidden";
        this.currentMessage = "Resetting password";

        if(this.forgotLocationId)
            this.resetEmail = await this.Api.post<string>("Account/ResetPasswordByObjects", null, { regNo1: this.regNo1, regNo2: this.regNo2 });
        else
          this.resetEmail = await this.Api.post<string>("Account/ResetPassword", null, { locationCode: this.locationId, regNo: this.regNo1 });

        if (this.resetEmail) {
            this.subForms.remind = "hidden";
            this.subForms.reminderSent = "visible";
        } else {
            alert("There is no user matching the information you have provided. Please try again.");
            this.subForms.remind = "visible";
        }
      this.subForms.loading = "hidden";

      this.userEmail = this.resetEmail;
    }

    public ForgotLocationId() {
        this.forgotLocationId = true;
    }

    public ResetForm() {
        this.subForms.login = "visible";
        this.subForms.reminderSent = "hidden";
        this.forgotLocationId = false;
    }

    public EndAnimationCompleted(event: any) {
        if (event.toState == false) {
            this.LoginComplete.emit(true);
        }
    }

    private changeMessage() {
        var index = Math.floor(Math.random() * this.loadingMessages.length);
        this.currentMessage = this.loadingMessages[index];

        setTimeout(() => {
            this.changeMessage();
        }, 5000);
    }

}


